import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { LookAndFeelSettingsFormMainSection } from './LookAndFeelSettingsFormMainSection';

export type ILookAndFeelSettingsFormValues = {
  appThemeColorPrimary?: string;
  iconId?: string;
};

export type ILookAndFeelSettingsFormProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<ILookAndFeelSettingsFormValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    mode: IFormMode;
    defaultValues?: DefaultValues<ILookAndFeelSettingsFormValues>;
    onSubmit?: SubmitHandler<ILookAndFeelSettingsFormValues>;
  };

export const LookAndFeelSettingsForm: React.FC<
  ILookAndFeelSettingsFormProps
> = (props) => {
  const { sx, defaultValues, onSubmit, ...other } = props;

  const form = useForm<ILookAndFeelSettingsFormValues>({
    defaultValues,
  });

  return (
    <ContentBlock.FormBody sx={sx} form={form} onSubmit={onSubmit} {...other}>
      <LookAndFeelSettingsFormMainSection form={form} />
    </ContentBlock.FormBody>
  );
};
